var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher"},[_c('select-element',{attrs:{"options":_vm.availableLocales,"border":false,"z-index":25},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }